import { COLLECTIONS } from '@crew/shared';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { demoStore } from '@/demo/demoStore';
import { IS_DEMO } from '@/demo/demoMode';
import { getFirebase } from '@/services/firebase';

/** מספר בקשות השינוי הממתינות, בזמן אמת. משמש לתג בניווט ובמסך הבית. */
export function usePendingRequestCount(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (IS_DEMO) {
      const push = () => setCount(demoStore.pendingRequests());
      push();
      return demoStore.subscribe(push);
    }
    const { db } = getFirebase();
    const q = query(collection(db, COLLECTIONS.changeRequests), where('status', '==', 'pending'));
    return onSnapshot(
      q,
      (snap) => setCount(snap.size),
      () => setCount(0),
    );
  }, []);
  return count;
}
